import config from '../config.json';

export default class Mail {
  constructor(data) {
    this.data = data;
  }

  async send() {
    try {
      const response = await fetch(config.CONTACT_FORM_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(this.data)
      });

      const json = await response.json();
      const status = response.status;

      return { json, status };
    } catch (error) {
      return {
        json: {
          message: ''
        },
        status: 500
      }
    }
  }
};
